import React, { useState } from 'react';
import { Loader2, Upload } from 'lucide-react';
import { api } from '@/lib/api';
import { toast } from 'sonner';

export const statusLabel = (status) => {
  if (status === 'draft') return 'Borrador';
  if (status === 'archived') return 'Archivado';
  return null;
};

export const matchesStatusFilter = (item, filter) => {
  const s = item.status || 'published';
  return filter === 'all' || s === filter;
};

export const StatusFilter = ({ value, onChange, testId = 'status-filter' }) => (
  <select
    value={value}
    onChange={(e) => onChange(e.target.value)}
    className="h-9 rounded-xl border border-gray-200 bg-white px-3 text-sm text-gray-700"
    data-testid={testId}
  >
    <option value="all">Todos los estados</option>
    <option value="published">Publicados</option>
    <option value="draft">Borradores</option>
    <option value="archived">Archivados</option>
  </select>
);

export const StatusBadge = ({ item, resource, onChanged }) => {
  const [busy, setBusy] = useState(false);
  const label = statusLabel(item.status);
  if (!label) return null;
  const isDraft = item.status === 'draft';

  const publish = async (e) => {
    e.stopPropagation();
    setBusy(true);
    try {
      await api.setContentStatus(resource, item.id, 'published');
      toast.success('Publicado');
      onChanged?.();
    } catch (err) {
      const d = err.response?.data?.detail;
      toast.error(d?.missing ? `Faltan traducciones: ${d.missing.join(', ')}` : 'No se pudo publicar');
    } finally {
      setBusy(false);
    }
  };

  return (
    <span className="inline-flex items-center gap-1" data-testid={`status-badge-${item.id}`}>
      <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${isDraft ? 'bg-amber-100 text-amber-700' : 'bg-gray-200 text-gray-600'}`}>
        {label}
      </span>
      <button
        onClick={publish}
        disabled={busy}
        title="Publicar"
        className="text-xs text-[#38B2AC] hover:underline inline-flex items-center gap-0.5"
        data-testid={`publish-btn-${item.id}`}
      >
        {busy ? <Loader2 size={12} className="animate-spin" /> : <Upload size={12} />}
        Publicar
      </button>
    </span>
  );
};
